import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { StatusEnum } from "../../../../../../commons/enums/status-enum";
import { manageFootballTeamService } from "../../../../../../commons";
import { ManageFootballHostedCompetition } from "../../../../../../commons/models/football/admin/manage-football-hosted-competition";
import { setFetchedCompetitionData } from "../../../fetched-competition-slice";

interface IManageHostedCompetitionInfoState {
  hostedCompetitionInfo: ManageFootballHostedCompetition;
  hostedCompetitionInfoStatus: StatusEnum;
}

export interface IHostedCompetitionOption {
  teamId: number;
  hostedCompetitionId: number;
}

const initialState: IManageHostedCompetitionInfoState = {
  hostedCompetitionInfo: new ManageFootballHostedCompetition(),
  hostedCompetitionInfoStatus: StatusEnum.Idle,
};

export const fetchManageHostedCompetition = createAsyncThunk(
  "manage/hostedCompetitionDetail",
  async (options: IHostedCompetitionOption, thunkAPI) => {
    try {
      const competition = await manageFootballTeamService.getHostedCompetitionDetail(
        options.teamId,
        options.hostedCompetitionId
      );
      thunkAPI.dispatch(setFetchedCompetitionData(competition));
      return competition;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const footballManageHostedCompetitionSlice = createSlice({
  name: "footballManageHostedCompetition",
  initialState: initialState,
  reducers: {
    cleanUpHostedCompetitionInfo(state) {
      state.hostedCompetitionInfo = new ManageFootballHostedCompetition();
      state.hostedCompetitionInfoStatus = StatusEnum.Idle;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchManageHostedCompetition.pending, (state) => {
        state.hostedCompetitionInfoStatus = StatusEnum.Loading;
      })
      .addCase(
        fetchManageHostedCompetition.fulfilled,
        (state, action: PayloadAction<ManageFootballHostedCompetition>) => {
          state.hostedCompetitionInfoStatus = StatusEnum.Succeeded;
          state.hostedCompetitionInfo = action.payload;
        }
      )
      .addCase(fetchManageHostedCompetition.rejected, (state) => {
        state.hostedCompetitionInfoStatus = StatusEnum.Failed;
      });
  },
});

export const { cleanUpHostedCompetitionInfo } = footballManageHostedCompetitionSlice.actions;
export default footballManageHostedCompetitionSlice.reducer;
